export default __webpack_public_path__ + "static/environment-87de54c8005f28229e4179a447d5a23f.png";